import { render, staticRenderFns } from "./_courseId.vue?vue&type=template&id=34d59caa&"
import script from "./_courseId.vue?vue&type=script&lang=js&"
export * from "./_courseId.vue?vue&type=script&lang=js&"
import style0 from "./_courseId.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports